<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>Enviar comprovante por E-mail</h2>
          </div>
        </div>
      </div>

      <div>
        <form [formGroup]="formularioDeEnvioDeComprovantePorEmail" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>

          <div class="form-group">
            <label for="email">E-mail</label>
            <input type="text" class="form-control" id="email" required trim="blur" name="nome" formControlName="email">
            <div
              *ngIf="formularioDeEnvioDeComprovantePorEmail.controls.email.invalid && (formularioDeEnvioDeComprovantePorEmail.controls.email.dirty || formularioDeEnvioDeComprovantePorEmail.controls.email.touched)"
              class="alert alert-danger">
              <div *ngIf="formularioDeEnvioDeComprovantePorEmail.controls.email.errors!.required">
                O campo E-mail é obrigatório.
              </div>
              <div *ngIf="formularioDeEnvioDeComprovantePorEmail.controls.email.errors!.email">
                O E-mail não é válido.
              </div>
            </div>
          </div>

          <div class="menu-formulario">
            <div class="menu-formulario-botoes margin-right-10">
              <button mat-mini-fab color="success" type="submit" matTooltip="Enviar"
                [disabled]="!formularioDeEnvioDeComprovantePorEmail.valid">
                <mat-icon>mail</mat-icon>
              </button>
            </div>
            <div class="menu-formulario-botoes">
              <button type="button" mat-mini-fab color="primary" (click)="telaAnterior()" matTooltip="Voltar">
                <mat-icon>west</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>